var _g, _g2, _g3, _g4, _g5, _line, _line2, _g6, _line3, _g7, _line4, _text, _text2, _text3, _g8, _g9, _g10, _line5, _line6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpNoRod(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "640px",
    height: "610px",
    viewBox: "0 0 640 610",
    enableBackground: "new 0 0 640 610",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M565.8,606.6v-13.3h8.7v1.5h-7.1v4.3h6.9v1.5h-6.9v6.1H565.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M576.6,606.6v-13.3h1.7v11.9h6.2v1.5H576.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M587,603.5c-0.5-1-0.8-2.2-0.8-3.5s0.3-2.5,0.8-3.5c0.5-1,1.3-1.9,2.3-2.5c1-0.6,2.2-0.9,3.5-0.9 s2.4,0.3,3.5,0.9c1,0.6,1.8,1.4,2.4,2.5s0.8,2.2,0.8,3.5s-0.3,2.5-0.8,3.5s-1.3,1.9-2.4,2.5c-1,0.6-2.2,0.9-3.5,0.9 s-2.4-0.3-3.5-0.9C588.3,605.3,587.5,604.5,587,603.5z M587.9,599.9c0,1,0.2,2,0.6,2.8s1,1.5,1.7,1.9c0.7,0.5,1.6,0.7,2.6,0.7 s1.8-0.2,2.6-0.7s1.3-1.1,1.7-1.9c0.4-0.8,0.6-1.7,0.6-2.8c0-1.6-0.5-2.9-1.4-3.9c-0.9-1-2.1-1.5-3.6-1.5c-1.5,0-2.7,0.5-3.6,1.5 C588.3,597.1,587.9,598.4,587.9,599.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M602.3,603.5c-0.5-1-0.8-2.2-0.8-3.5s0.3-2.5,0.8-3.5c0.5-1,1.3-1.9,2.3-2.5c1-0.6,2.2-0.9,3.5-0.9 s2.4,0.3,3.5,0.9c1,0.6,1.8,1.4,2.4,2.5s0.8,2.2,0.8,3.5s-0.3,2.5-0.8,3.5s-1.3,1.9-2.4,2.5c-1,0.6-2.2,0.9-3.5,0.9 s-2.4-0.3-3.5-0.9C603.6,605.3,602.8,604.5,602.3,603.5z M603.2,599.9c0,1,0.2,2,0.6,2.8s1,1.5,1.7,1.9c0.7,0.5,1.6,0.7,2.6,0.7 s1.8-0.2,2.6-0.7s1.3-1.1,1.7-1.9c0.4-0.8,0.6-1.7,0.6-2.8c0-1.6-0.5-2.9-1.4-3.9c-0.9-1-2.1-1.5-3.6-1.5c-1.5,0-2.7,0.5-3.6,1.5 C603.6,597.1,603.2,598.4,603.2,599.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M617.3,606.6v-13.3h5.4c1.2,0,2.2,0.4,3,1.1s1.2,1.7,1.2,2.9c0,0.6-0.1,1.1-0.3,1.6 c-0.2,0.5-0.5,0.9-0.8,1.2c-0.3,0.3-0.7,0.6-1.1,0.8c-0.4,0.2-0.9,0.3-1.3,0.3l3.6,5.4h-2l-3.4-5.3h-2.7v5.3H617.3z M618.9,599.8 h3.5c0.8,0,1.4-0.2,1.9-0.7c0.5-0.5,0.8-1.1,0.8-1.8s-0.2-1.4-0.7-1.8s-1.1-0.7-1.9-0.7h-3.5V599.8z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 137.6,
    y: 123.1,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 280.2,
    height: 389
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.7,
    y: 146.2,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 234,
    height: 342.8
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M565.8,15.6c-0.4-0.9-0.5-1.8-0.5-2.8s0.2-1.9,0.5-2.8c0.4-0.9,0.8-1.6,1.5-2.2c0.6-0.6,1.3-1.1,2.2-1.4 c0.8-0.3,1.7-0.5,2.7-0.5c2.1,0,3.8,0.9,5.1,2.6l-1.4,0.8c-0.4-0.6-0.9-1.1-1.6-1.4c-0.7-0.4-1.4-0.5-2.1-0.5 c-1.5,0-2.7,0.5-3.7,1.5s-1.5,2.3-1.5,3.9c0,1,0.2,2,0.7,2.8s1.1,1.5,1.8,1.9s1.7,0.7,2.6,0.7c0.7,0,1.4-0.2,2.1-0.5 c0.7-0.4,1.2-0.8,1.6-1.4l1.4,0.8c-1.3,1.8-3,2.7-5.1,2.7c-1,0-1.8-0.2-2.7-0.5c-0.8-0.3-1.6-0.8-2.2-1.4 C566.6,17.2,566.2,16.5,565.8,15.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M579.3,19.4V6.1h8.7v1.5H581v4.3h6.9v1.5H581V18h7.1v1.5H579.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M590.7,19.4V6.1h1.7v13.3H590.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M595.3,19.4V6.1h1.7V18h6.2v1.5H595.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M605.3,19.4V6.1h1.7v13.3H605.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M610.1,19.4V6.1h1.7l7.7,10.4V6.1h1.7v13.3h-1.6l-7.8-10.6v10.6H610.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M624.3,15.6c-0.4-0.9-0.5-1.8-0.5-2.8s0.2-2,0.5-2.8c0.4-0.9,0.8-1.6,1.5-2.2c0.6-0.6,1.3-1.1,2.2-1.4 c0.8-0.3,1.7-0.5,2.7-0.5c2.1,0,3.9,0.8,5.2,2.5l-1.3,0.8c-0.4-0.6-1-1-1.7-1.3c-0.7-0.3-1.4-0.5-2.2-0.5c-1.5,0-2.7,0.5-3.7,1.5 s-1.5,2.3-1.5,3.9c0,1,0.2,2,0.7,2.8s1.1,1.5,1.8,1.9c0.8,0.5,1.7,0.7,2.6,0.7c0.7,0,1.4-0.1,2.1-0.4s1.2-0.6,1.5-1v-2.7h-4.6v-1.5 h6.2v4.8c-0.6,0.7-1.4,1.3-2.3,1.7c-0.9,0.4-1.9,0.6-2.9,0.6c-0.9,0-1.8-0.2-2.7-0.5s-1.6-0.8-2.2-1.4 C625.1,17.2,624.6,16.5,624.3,15.6z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M540.7,80.5V67.1h5.4c1.2,0,2.2,0.4,3,1.1s1.2,1.7,1.2,2.9c0,0.6-0.1,1.1-0.3,1.6c-0.2,0.5-0.5,0.9-0.8,1.2 c-0.3,0.3-0.7,0.6-1.1,0.8c-0.4,0.2-0.9,0.3-1.3,0.3l3.6,5.4h-2l-3.4-5.3h-2.7v5.3H540.7z M542.3,73.7h3.5c0.8,0,1.4-0.2,1.9-0.7 c0.5-0.5,0.8-1.1,0.8-1.8s-0.2-1.4-0.7-1.8s-1.1-0.7-1.9-0.7h-3.5V73.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M553.1,77.3c-0.6-1-0.8-2.2-0.8-3.5s0.3-2.5,0.8-3.5c0.5-1,1.3-1.9,2.3-2.5c1-0.6,2.2-0.9,3.5-0.9 c1.3,0,2.4,0.3,3.5,0.9c1,0.6,1.8,1.4,2.4,2.5s0.8,2.2,0.8,3.5s-0.3,2.5-0.8,3.5s-1.3,1.9-2.4,2.5c-1,0.6-2.2,0.9-3.5,0.9 c-1.3,0-2.4-0.3-3.5-0.9C554.4,79.2,553.7,78.4,553.1,77.3z M554,73.8c0,1,0.2,2,0.6,2.8c0.4,0.8,1,1.5,1.7,1.9 c0.7,0.5,1.6,0.7,2.6,0.7c1,0,1.8-0.2,2.6-0.7s1.3-1.1,1.7-1.9s0.6-1.7,0.6-2.8c0-1.6-0.5-2.9-1.4-3.9s-2.1-1.5-3.6-1.5 c-1.5,0-2.7,0.5-3.6,1.5C554.4,70.9,554,72.2,554,73.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M568.1,80.5V67.1h4.6c1.4,0,2.6,0.3,3.6,0.9c1,0.6,1.8,1.4,2.4,2.4c0.6,1,0.8,2.1,0.8,3.4 c0,0.9-0.2,1.8-0.5,2.6c-0.3,0.8-0.8,1.5-1.4,2.1s-1.3,1.1-2.2,1.4c-0.9,0.3-1.8,0.5-2.8,0.5H568.1z M569.8,79h2.9 c1,0,2-0.2,2.8-0.7c0.8-0.5,1.4-1.1,1.8-1.9c0.4-0.8,0.6-1.6,0.6-2.6c0-1-0.2-1.9-0.6-2.6c-0.4-0.8-1-1.4-1.8-1.9 c-0.8-0.5-1.7-0.7-2.8-0.7h-2.9V79z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    x1: 403.8,
    y1: 542.5,
    x2: 151.7,
    y2: 542.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "401.1,533.5 416.7,542.5 401.1,551.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "154.3,533.5 138.7,542.5 154.3,551.5  "
  }))))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.4647,
    x1: 417.8,
    y1: 523.6,
    x2: 417.8,
    y2: 560
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.3987,
    x1: 137.6,
    y1: 523.6,
    x2: 137.6,
    y2: 561.4
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    x1: 97.7,
    y1: 137.5,
    x2: 97.7,
    y2: 497.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "88.7,140.1 97.7,124.6 106.7,140.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "88.7,495.1 97.7,510.6 106.7,495.1  "
  }))))), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.6287,
    x1: 76.8,
    y1: 512.1,
    x2: 120.2,
    y2: 512.1
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.9409,
    x1: 57.4,
    y1: 137.3,
    x2: 57.4,
    y2: 588.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "48.6,139.8 57.4,124.6 66.2,139.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "48.6,586 57.4,601.3 66.2,586  "
  }))))), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.5898,
    x1: 38.9,
    y1: 123.1,
    x2: 120.2,
    y2: 123.1
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 40.1943 323.3137)",
    fill: "#464545",
    fontFamily: "'ProximaNova-Regular'",
    fontSize: 18
  }, "A")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 81.3848 323.3137)",
    fill: "#464545",
    fontFamily: "'ProximaNova-Regular'",
    fontSize: 18
  }, "B")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 271.6294 559.9758)",
    fill: "#464545",
    fontFamily: "'ProximaNova-Regular'",
    fontSize: 18
  }, "C")), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 1.9825,
    x1: 277.7,
    y1: 87.8,
    x2: 277.7,
    y2: 112.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "271.8,89.6 277.7,79.3 283.6,89.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "271.8,111 277.7,121.2 283.6,111  "
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M292.5,97.1l3-3.1h1.3v12h-1.5v-10l-1.9,2.1L292.5,97.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M299.4,104.3l0.9-1c0.8,1.1,1.9,1.6,3.3,1.6c0.8,0,1.5-0.2,2-0.7s0.8-1.1,0.8-1.8c0-0.8-0.3-1.4-0.8-1.9 s-1.2-0.7-2-0.7c-1.1,0-2,0.4-2.8,1.1l-1.1-0.4V94h7.3v1.3h-5.9v4.2c0.3-0.3,0.7-0.6,1.2-0.8s1-0.3,1.6-0.3c0.5,0,1,0.1,1.4,0.3 s0.9,0.4,1.2,0.7c0.4,0.3,0.6,0.7,0.8,1.2s0.3,1.1,0.3,1.7c0,1.2-0.4,2.1-1.2,2.9c-0.8,0.7-1.8,1.1-3.1,1.1 C301.8,106.2,300.4,105.6,299.4,104.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M309.4,102.2V101h4.3v1.2H309.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M315.2,95.7c0.5-0.6,1-1.1,1.8-1.4c0.7-0.3,1.5-0.5,2.4-0.5c0.5,0,1,0.1,1.5,0.2c0.5,0.1,0.9,0.4,1.3,0.6 c0.4,0.3,0.7,0.7,0.9,1.1c0.2,0.5,0.3,1,0.3,1.6c0,0.5-0.1,1-0.3,1.5s-0.5,1-0.8,1.4c-0.3,0.4-0.7,0.9-1.3,1.5 c-0.5,0.5-1.1,1-1.6,1.4s-1.2,1-1.9,1.5h5.9v1.3h-8.2v-1.2c0.8-0.6,1.5-1.2,2-1.6c0.5-0.4,1.1-0.9,1.6-1.4c0.6-0.5,1-0.9,1.3-1.3 c0.3-0.4,0.6-0.7,0.9-1.1c0.3-0.4,0.5-0.7,0.6-1.1c0.1-0.3,0.2-0.7,0.2-1c0-0.7-0.2-1.3-0.7-1.6s-1.1-0.6-1.8-0.6 c-0.7,0-1.3,0.1-1.9,0.4c-0.6,0.3-1,0.6-1.4,1.1L315.2,95.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M325.8,100c0-0.6,0.1-1.2,0.2-1.8c0.1-0.6,0.3-1.1,0.5-1.7s0.5-1,0.9-1.4c0.3-0.4,0.8-0.7,1.3-1 c0.5-0.2,1.1-0.4,1.7-0.4c0.6,0,1.2,0.1,1.7,0.4c0.5,0.2,1,0.6,1.3,1c0.3,0.4,0.6,0.9,0.9,1.4c0.2,0.5,0.4,1.1,0.5,1.7 c0.1,0.6,0.2,1.2,0.2,1.8c0,0.6-0.1,1.2-0.2,1.8c-0.1,0.6-0.3,1.1-0.5,1.7c-0.2,0.5-0.5,1-0.9,1.4s-0.8,0.7-1.3,1 c-0.5,0.2-1.1,0.4-1.7,0.4c-0.6,0-1.2-0.1-1.7-0.4c-0.5-0.2-1-0.6-1.3-1c-0.3-0.4-0.6-0.9-0.9-1.4s-0.4-1.1-0.5-1.7 C325.8,101.2,325.8,100.6,325.8,100z M327.3,100c0,0.6,0.1,1.2,0.2,1.8c0.1,0.6,0.3,1.1,0.5,1.5c0.2,0.5,0.5,0.9,1,1.1 c0.4,0.3,0.9,0.4,1.4,0.4s1-0.1,1.4-0.4s0.7-0.7,1-1.1c0.2-0.5,0.4-1,0.5-1.5c0.1-0.6,0.2-1.1,0.2-1.8c0-0.5,0-1-0.1-1.4 c-0.1-0.5-0.2-0.9-0.3-1.3c-0.2-0.4-0.3-0.8-0.6-1.1s-0.5-0.6-0.9-0.7c-0.4-0.2-0.8-0.3-1.2-0.3c-0.4,0-0.8,0.1-1.2,0.3 c-0.4,0.2-0.6,0.4-0.9,0.7s-0.4,0.7-0.6,1.1c-0.2,0.4-0.3,0.9-0.3,1.3C327.3,99,327.3,99.5,327.3,100z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M336.7,101.6c0-0.9,0.2-1.6,0.5-2.3c0.4-0.7,0.9-1.2,1.5-1.6c0.7-0.4,1.4-0.6,2.3-0.6 c1.3,0,2.4,0.5,3.2,1.5l-0.9,0.8c-0.5-0.7-1.3-1.1-2.2-1.1c-0.9,0-1.6,0.3-2.2,0.9s-0.8,1.4-0.8,2.4c0,1,0.3,1.8,0.8,2.4 s1.3,1,2.2,1c0.9,0,1.6-0.4,2.2-1.1l0.9,0.8c-0.8,1-1.8,1.5-3.2,1.5c-1.3,0-2.3-0.4-3.1-1.3C337.1,104,336.7,102.9,336.7,101.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M346.1,106v-8.7h1.3v1.3c0.2-0.3,0.6-0.7,1.2-1s1.1-0.5,1.7-0.5c0.6,0,1.1,0.2,1.5,0.5s0.7,0.7,0.8,1.2 c0.3-0.4,0.7-0.8,1.2-1.1s1.1-0.5,1.7-0.5c0.8,0,1.4,0.2,1.8,0.7s0.6,1.1,0.6,2v6.3h-1.3v-5.9c0-1.2-0.5-1.8-1.6-1.8 c-0.4,0-0.9,0.1-1.3,0.4s-0.8,0.6-1,0.9v6.4h-1.3v-5.9c0-1.2-0.5-1.8-1.6-1.8c-0.4,0-0.8,0.1-1.3,0.4c-0.4,0.3-0.8,0.6-1,1v6.4 H346.1z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 53.3,
    y: 71.2,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.6525,
    strokeDasharray: "7,4",
    width: 450.6,
    height: 5.9
  })), /*#__PURE__*/React.createElement("rect", {
    x: 502.4,
    y: 68.1,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.2603,
    width: 24,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 68.1,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.2603,
    width: 24,
    height: 12
  }))), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#474646",
    strokeWidth: 3.043,
    x1: 6.5,
    y1: 13.1,
    x2: 548.9,
    y2: 13.1
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#474646",
    strokeWidth: 3.043,
    x1: 6.5,
    y1: 602,
    x2: 548.9,
    y2: 602
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpNoRod);
export default __webpack_public_path__ + "static/media/help_noRod.53b237947fc414e945aa5bdeb22a7701.svg";
export { ForwardRef as ReactComponent };